'use strict';

var nocUtil = require('../../util/noc-util');
var zabbixUtil = require('../pages/alarm/zabbix-util');

module.exports = /*@ngInject*/ ["train", "NgTableParams", "$filter", function DetailWindowMonitoringController(train, NgTableParams, $filter) {
    var vm = this;
    vm.train = train;
    init();
    vm.issueLength = -1;

    /*
    FUNCTIONS
    */

    function init() {
        /**
         * If train level is set but no noc issues (train.issues) are present, warn the user that there are zabbix issues.
         */
        if (train.diagnostics.hasZabbixIssues) {
            vm.train.issues.push({
                type: 'zabbix-alarm',
                severity: train.severity,
                description: 'Zabbix has indicated 1 or more alarms.'
            });
        }
    }

    vm.tableParamDiagnostics = new NgTableParams({
        page: 1,
        count: 1,          // count per page
        sorting: {
            name: 'asc'
        }
    }, {
        counts: [],
        total: 0,
        getData: function (params) {
            var orderedData = [vm.train];
            params.count(1);
            params.total(1);
            return orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
        },
        filterDelay: 0
    });

    vm.tableParamIssues = new NgTableParams({
        page: 1,
        count: 5,          // count per page
        sorting: {
            name: 'asc'
        }
    }, {
        counts: [],
        total: 0,
        getData: function (params) {
            vm.issueLength = vm.train.issues.length;
            var filteredData = params.filter() ?
                $filter('filter')(vm.train.issues, params.filter()) :
                vm.train.issues;
            var orderedData = params.sorting() ?
                $filter('orderBy')(filteredData, params.orderBy()) :
                vm.train.issues;
            params.total(orderedData.length);
            return orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
        },
        filterDelay: 0
    });

    vm.getLabelClassForUsers = function(users,trip){
        return nocUtil.verifyLabelBasedOnUsersAndSchedule(users,trip);
    };


    vm.getColor = function(level) {
        return zabbixUtil.getPriorityColor(level);
    }
}];
